/// <reference path="../types/index.d.ts" />

import '../client_forms/mculinary3/style.css';
import FormStructure from './mculinary3/form_structure';

export default FormStructure;